import { SubscriptionType } from '../enums';

export const ABOVE_PRO = [
  SubscriptionType.ENTERPRISE,
  SubscriptionType.SELLWITH_SELECT,
  SubscriptionType.BUYWITH_SELECT,
  SubscriptionType.ADMIN,
  SubscriptionType.BUYWITH_ENTERPRISE,
];
